import { useStudentStore } from "../../hooks/use-student-store";


const TimeStatusTable = () => {
  const { submission, } = useStudentStore();

  if (!submission) return null;

  const isCompleted = submission.status === "COMPLETED";

  return (
    <div className="mt-6 overflow-hidden rounded-lg border border-gray-200">
      <table className="w-full">
        <thead>
          <tr className="bg-[#3d3d6b]">
            <th className="py-2.5 px-4 text-left text-sm font-medium text-white">Time</th>
            <th className="py-2.5 px-4 text-left text-sm font-medium text-white">Status</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <tr>
            <td className="py-3 px-4 text-sm text-gray-900">
              {/* {formatTime(timeSpentSeconds)} */}
              23 mins
            </td>
            <td className="py-3 px-4 text-sm text-gray-900">
              {isCompleted ? "Ready for Class!" : "Incomplete"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TimeStatusTable;
